import "./complementary-products";

class ProductDetails extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (e) => {
      if (e.target.closest("[data-show-pattern]")) {
        this._showPattern();
      } else if (e.target.closest("[data-show-details]")) {
        this._showDetails();
      }
    });

    this.addEventListener("product-recommendations:no-results", () => {
      console.log("no recommendations");
      this.classList.add("product-details--no-recommendations");
    });
  }

  _showPattern() {
    this.style.height = `${this.getBoundingClientRect().height}px`;

    this.patternInfo.style.opacity = 0;
    this.patternInfo.style.display = "block";
    this.inner.style.height = `${this.inner.getBoundingClientRect().height}px`;

    window.requestAnimationFrame(() => {
      console.log(
        "this.patternInfo.getBoundingClientRect().height",
        this.patternInfo.getBoundingClientRect().height
      );
      this.inner.style.height = `${
        this.patternInfo.getBoundingClientRect().height
      }px`;

      const onEnd = () => {
        this.content.removeEventListener("transitionend", onEnd);
        this.patternInfo.style.opacity = null;
        this.content.style.display = "none";
        this.showDetailsButton.focus();
      };

      this.content.addEventListener("transitionend", onEnd);
      this.content.style.opacity = 0;
    });
  }

  _showDetails() {
    this.content.style.opacity = 0;
    this.content.style.display = null;
    this.inner.style.height = `${this.inner.getBoundingClientRect().height}px`;

    window.requestAnimationFrame(() => {
      const onHeightEnd = (e) => {
        if (e.target !== this.inner) return;

        this.inner.removeEventListener("transitionend", onHeightEnd);
        this.inner.style.height = null;
        this.style.height = null;
      };

      this.inner.addEventListener("transitionend", onHeightEnd);

      this.inner.style.height = `${
        this.content.getBoundingClientRect().height
      }px`;

      const onEnd = () => {
        this.patternInfo.removeEventListener("transitionend", onEnd);
        this.content.style.opacity = null;
        this.patternInfo.style.display = null;
        this.showPatternButton.focus();
      };

      this.patternInfo.addEventListener("transitionend", onEnd);
      this.patternInfo.style.opacity = 0;
    });
  }

  get inner() {
    return this.querySelector(".product-details__inner");
  }

  get content() {
    return this.querySelector(".product-details__content");
  }

  get patternInfo() {
    return this.querySelector(".product-details__pattern-info");
  }

  get showPatternButton() {
    return this.querySelector("[data-show-pattern]");
  }

  get showDetailsButton() {
    return this.querySelector("[data-show-details]");
  }
}

if (!customElements.get("product-details")) {
  customElements.define("product-details", ProductDetails);
}
